import React from 'react';
import { VerticalTabsItemProps } from '../VerticalTabsItem.types';
import { VerticalTabsContextValue } from '../../VerticalTabs/VerticalTabsContext';
import { st, classes, cssStates } from '../VerticalTabsItem.st.css';
import { Affix } from './Affix';
import { Text } from '../..';
import { SIZE } from '../../VerticalTabs/VerticalTabs.constants';
import { DATA_HOOKS } from '../VerticalTabsItem.constants';

export type TitleItemProps = Pick<
  VerticalTabsItemProps,
  'children' | 'dataHook' | 'prefixIcon' | 'suffixIcon'
> & {
  baseSkin?: VerticalTabsContextValue['skin'];
  size?: VerticalTabsContextValue['size'];
};

const TitleItem = ({
  children,
  dataHook,
  prefixIcon,
  suffixIcon,
  size,
  baseSkin,
}: TitleItemProps) => (
  <div
    className={st(
      classes.root,
      classes.title,
      cssStates({
        size,
        baseSkin,
        suffixIcon: !!suffixIcon,
        prefixIcon: !!prefixIcon,
      }),
    )}
    data-hook={dataHook}
  >
    <Affix
      dataHook={DATA_HOOKS.ITEM_PREFIX_ICON}
      size={size}
      className={st(classes.prefixIcon)}
    >
      {prefixIcon}
    </Affix>

    <Text
      className={classes.text}
      light
      secondary
      weight={size === SIZE.TINY ? 'bold' : 'thin'}
      size={size === SIZE.MEDIUM ? SIZE.SMALL : size}
      dataHook={DATA_HOOKS.ITEM_TEXT}
    >
      {children}
    </Text>

    <Affix
      dataHook={DATA_HOOKS.ITEM_SUFFIX_ICON}
      size={size}
      className={classes.suffixIcon}
    >
      {suffixIcon}
    </Affix>
  </div>
);

export { TitleItem };
